export default __webpack_public_path__ + "static/media/6.dbca2224.jpg";